import { useQuery } from "@tanstack/react-query";
import { getClientLedger } from "api/client.api";
import { DEFAULT_STALE_TIME } from "config/constants";

export const useGetClientLedger = (clientId, params = {}) => {
  return useQuery({
    queryKey: ["clients", clientId, "ledger", params],
    queryFn: () => getClientLedger(clientId, params),
    enabled: !!clientId,
    staleTime: DEFAULT_STALE_TIME,
  });
};
